import { useAtom, useSetAtom } from "jotai";
import { selectedMetricForLineageAtom } from "../state";
import RightSidebarButton from "@/features/Navigation/components/RightSidebarButton";
import { rightDrawerOpenAtom } from "@/features/Navigation/state";
import clsx from "clsx";
import { MetricLineageDisplay } from "./MetricLineageDisplay";
import { useMemo } from "react";

export function LineagePanel() {
    const [selectedMetric, setSelectedMetric] = useAtom(
        selectedMetricForLineageAtom,
    );
    const setRightDrawerOpen = useSetAtom(rightDrawerOpenAtom);

    const parsedMetric = useMemo(() => {
        if (!selectedMetric?.metric?.lineagedValues || !selectedMetric.period) {
            return null;
        }

        return (selectedMetric.metric.lineagedValues as any[]).find(
            (pm) => pm.period === selectedMetric.period,
        );
    }, [selectedMetric]);

    if (!selectedMetric) {
        return null;
    }

    const hasLineageData =
        selectedMetric.metric?.lineagedValues &&
        Array.isArray(selectedMetric.metric.lineagedValues) &&
        selectedMetric.metric.lineagedValues.length > 0;

    return (
        <div
            className={clsx(
                "px-6",
                "custom-scrollbar absolute inset-0 flex min-h-0 flex-col overflow-hidden",
            )}
        >
            <div className="sticky my-4 flex flex-col">
                <RightSidebarButton
                    onClick={() => {
                        setRightDrawerOpen(false);
                        setSelectedMetric(null);
                    }}
                />
                <h2 className="pageheading ">
                    {selectedMetric.metric.description?.name}
                    {parsedMetric &&
                        ` - ${selectedMetric.period
                            .split(/<\d+>/)
                            .map((date) => date.split("-").reverse().join("/"))
                            .join(" - ")}`}
                </h2>
            </div>
            <div className="custom-scrollbar hide-scrollbar overflow-y-scroll">
                {hasLineageData && parsedMetric ? (
                    <MetricLineageDisplay
                        parsedMetric={parsedMetric}
                        metric={selectedMetric.metric}
                    />
                ) : (
                    <div
                        className={clsx(
                            "p-4",
                            "flex flex-col",
                            "gap-4 rounded",
                        )}
                        style={{ backgroundColor: "#2E3849" }}
                    >
                        <h3 className="heading-s">
                            Data for this field is missing or unavailable.
                        </h3>
                        <p className="body-s">
                            Please contact your admin or company representative
                            for more information
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
}
